import React from 'react';
import PropTypes from 'prop-types';
import BaseWidget from '../BaseWidget';
import Image from './Image';
import ClassNames from './Image.less';
import { resolveTestId } from '@cvent/nucleus-test-automation';
import renderRichText from '../../utils/renderRichText';

/**
 * Data wrapper for the Image widget.
 */
export default class ImageWidget extends BaseWidget {
  static displayName = 'ImageWidget';
  static propTypes = {
    type: PropTypes.string,
    config: PropTypes.object,
    classes: PropTypes.object,
    style: PropTypes.object,
    translate: PropTypes.func,
    enableHyperlink: PropTypes.bool
  };
  static defaultProps = {
    classes: ClassNames
  };
  getStyleObject() {
    // The style set in the canvas for the image alignment actually needs to be applied to the container.
    // There is no textAlign style option for the container, so we can just merge the alignment style in here.
    return {
      container: {
        ...super.getStyleObject().container,
        textAlign: this.getElementText('image').textAlign
      },
      image: this.getElementText('image'),
      imageText: this.getElementInlineStyle('imageText')
    };
  }
  render() {
    const { classes, config, translate, enableHyperlink, style } = this.props;
    const styleObject = this.getStyleObject();
    return (
      <Image
        {...resolveTestId(this.props)}
        classes={classes}
        style={styleObject}
        imgUrl={config.asset ? config.asset.assetUri : ''}
        altText={config.altText}
        hyperlink={enableHyperlink && config.hyperlink}
        description={renderRichText(config.description, translate, style.palette, styleObject.imageText)}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./~/nucleus-widgets/lib/Image/ImageWidget.js